import _default from './Flag';
export { _default as default };